<svg width="12" height="8" viewBox="0 0 12 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0V8H0L12 0Z"/>
</svg>
